import React from "react";

import CareerCore from "../components/CareerCore";
import CommonContainer from "../components/CommonContainer";
import { useSiteData } from "../utils/graphql";

const HomePage = () => {
  console.log("== In HomePage ==");
  const { careerConfig, homeArr, jobArr } = useSiteData();

  return (
    <CommonContainer
      homeArr={homeArr}
      careerConfig={careerConfig}
      jobArr={jobArr}
    >
      <CareerCore
        careerConfig={careerConfig}
        homeArr={homeArr}
        jobArr={jobArr}
      />
    </CommonContainer>
  );
};

HomePage.propTypes = {};

export default HomePage;
